import { useSuspenseQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useConfig } from 'wagmi'

import { AaveData, aaveDataLayer, aaveDataLayerSelectFn } from './query'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { SuspenseQueryWith } from '@/utils/types'

export interface UseAaveDataLayerParams {
  chainId: number
}
export type UseAaveDataLayerResultOnSuccess = SuspenseQueryWith<{
  aaveData: AaveData
}>

export function useAaveDataLayer({ chainId }: UseAaveDataLayerParams): UseAaveDataLayerResultOnSuccess {
  const { account } = useConnectedAddress({ throwOnNotConnected: false })
  const wagmiConfig = useConfig()

  const result = useSuspenseQuery({
    ...aaveDataLayer({
      wagmiConfig,
      chainId,
      account,
    }),
    select: useMemo(() => aaveDataLayerSelectFn(), []),
  })

  return {
    ...result,
    aaveData: result.data,
  }
}
